import styled, { css } from 'styled-components';
import Button from '../Button';
import Icon from '../Icon';

export const StyledCheckBox = styled.div`
  max-height: 406px;
  width: auto;
  min-width: 268px;
  max-width: 316px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 0 12px 0;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-left: 0;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  height: auto;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
`;

export const BaseHeader = styled.div`
  height: auto;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  display: flex;
  justify-content: space-between;
`;

export const ControlledHeader = styled.div`
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  margin: 0 -12px;
  padding: 0 12px 18px;
`;

export const SearchBar = styled.input.attrs({
  type: 'text'
})`
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  border-radius: 6px;
  height: 34px;
  width: 100%;
  border: none;
  padding-left: 9px;
  margin-bottom: 16px;
`;

export const ArrowUp = styled(Icon).attrs({
  icon: 'TR5-Arrow_up'
})`
  width: 12px;
  height: 16px;
  cursor: pointer;
`;

export const StyledContent = styled.div`
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 18px;
    background: ${({ theme }) => theme.COLORS.BASE};
    border: 6px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-button {
    height: 24px;
  }
`;

export const HoverWrapper = styled.div`
  display: inherit;
  width: inherit;
  padding: 8px 0;

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};

    span {
      opacity: 1;
    }
  }
`;
const ListVariant = {
  nested: css`
    padding-top: 11px;
  `
};

export const List = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;

  ${({ variant }) => ListVariant[variant]}
`;

export const StyledLabel = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const ChildWrapper = styled(List)`
  display: flex;
  padding-left: 12px;
  width: 100%;
`;

export const ChildElement = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &:last-child {
    padding-bottom: 0px;
  }
`;

export const CheckBox = styled.input.attrs(() => ({
  type: 'checkbox'
}))`
  outline: 0;
  margin-right: 15px;
`;

export const Only = styled.span`
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: 18px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  margin-left: auto;
  opacity: 0;
  cursor: pointer;
  padding-right: 16px;
`;

export const StyledFooter = styled.div`
  display: flex;
  border-top: 2px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  height: 70px;
  margin: 0 -12px;
`;

export const ApplyButton = styled(Button)`
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  padding: 9px 26px;
  margin: 12px;
  margin-left: auto;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  height: 36px;
`;
